import React, { useEffect, useState } from "react";
import Layout from "../../../Layout";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import HeaderBread from "../../../components/HeaderBread";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import CustomizedTable from "../../../components/UI/CustomizedTable";
import Logs from "../../../components/Logs";
import {
  deleteWebpage,
  getAllWebpage,
  updateWebpage,
} from "../../../utils/ApiCalls/WebPages";
import DeletePop from "../../../constants/ErrorPermissionModal";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import {
  deleteMenuList,
  updateManyMenuList,
} from "../../../utils/ApiCalls/MenuList";
import { addlog } from "../../../utils/ApiCalls/Logs";
import { message } from "antd";
import Swal from "sweetalert2";
import ValidDateUI from "../../../constants/validDateUI";
import { constants } from "../../../constants/constants";
import ValidDateUI1 from "../../../constants/ValidDateUI1";
import { LOG_ACTIONS } from "../../../utils/Constant/LogConstant";

const DestinationPage = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState();
  const [count, setCount] = useState(0);
  const [active, setActive] = useState("listing");
  const [{ userDetails, permission }, dispatch] = useDataLayerValue();

  const [sort, setSort] = useState("");
  const [order, setOrder] = useState("");
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Destinations List",
      route: "/website/cms/webpages/our-ship",
    },
  ];

  
  
    const locationP = useLocation();
  
    const [page, setPage] = useState(
      () => parseInt(new URLSearchParams(locationP.search).get("page")) || 1
    );
    const [pageSize, setPageSize] = useState(
      () => parseInt(new URLSearchParams(locationP.search).get("pageSize")) || 10
    );
    const [search, setSearch] = useState(
      () => new URLSearchParams(locationP.search).get("search") || ""
    );
  
    useEffect(() => {
      const params = new URLSearchParams(locationP.search);
      const pageParam = parseInt(params.get("page")) || 1;
      const pageSizeParam = parseInt(params.get("pageSize")) || 10;
      const searchParam = params.get("search") || "";
  
      // setPage(pageParam);
      // setPageSize(pageSizeParam);
      setSearch(searchParam);
    }, [locationP.search]);
  
    useEffect(() => {
      const params = new URLSearchParams();
      const currentParams = new URLSearchParams(locationP.search);
  
      params.set("page", page);
      params.set("pageSize", pageSize);
      if (search) params.set("search", search);
  
      if (currentParams.toString() !== params.toString()) {
        navigate({ search: params.toString() }, { replace: true });
      }
    }, [page, pageSize, search, navigate, locationP.search]);
  
  const handleUpdate = async (id, values, title, location_id) => {
    if (checkPermission(permission, "update_per", "webpages",window?.location?.pathname)) {
      let data = await updateWebpage(id, values);
      if (values.slug) {
        let menu = await updateManyMenuList({
          url: `destinations/${values.slug}`,
          is_active: values.is_active,
        });
      }
      if (data.error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.error,
        });
      } else {
        addlog(
          "Webpage " +
            (values.is_active !== undefined
              ? values.is_active === 1
                ? LOG_ACTIONS.ACTIVATED
                : LOG_ACTIONS.DEACTIVATED
              : LOG_ACTIONS.UPDATED),
          values.slug,
          { ...values, id, title, location_id },
          userDetails.id
        );
      }
      await getData(page);
    } else {
      message.error("Update permission missing");
    }
  };
  const columns = [
    {
      title: "No",
      width: 2,
      dataIndex: "id",
      key: "position",
      fixed: "left",
      render: (position, record, index) => (page - 1) * pageSize + index + 1,
    },
    {
      title: "Title",
      width: 400,
      dataIndex: "page_name",
      key: "page_name",
      fixed: "left",
    },
    {
      title: "Valid date",
      dataIndex: "valid_date",
      key: "valid_till",

      render: (text, record, index) => {
        return <ValidDateUI1 record={record} handleUpdate={handleUpdate} />;
      },
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      sorter: (a, b) => "",

      render: (item, record, index) => {
        if (item) {
          if (new Date(record.valid_to) < new Date(new Date())) {
            handleUpdate(
              record.id,
              {
                is_active: 0,
                slug: record.slug,
              },
              record.title
            );
          }
        }

        return (
          <div className="custom-control custom-switch">
            <input
              type="checkbox"
              checked={
                !(new Date(record.valid_to) < new Date(new Date())) && item
                  ? true
                  : false
              }
              onChange={(value) => {
                try {
                  if (new Date(record.valid_from) > new Date(new Date())) {
                    throw new Error(`Webpage is not yet started`);
                  }

                  if (new Date(record.valid_to) < new Date(new Date())) {
                    throw new Error(`Webpage is expired`);
                  }
                  handleUpdate(
                    record.id,
                    {
                      is_active: value.target.checked ? 1 : 0,
                      slug: record.slug,
                    },
                    record.title
                  );
                } catch (error) {
                  dispatch({
                    type: "SET_LOADING",
                    loading: false,
                  });

                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: error.message,
                  });
                }
              }}
              className="custom-control-input"
              id={"customSwitch1" + index}
            />
            <label
              className="custom-control-label"
              style={{}}
              htmlFor={"customSwitch1" + index}
            ></label>
          </div>
        );
      },
    },
    {
      title: "Action",
      key: "operation",
      width: 30,
      render: (text, record) => (
        <div className="table_action_btn">
          <div
            onClick={() =>
              navigate("/website/webpages/destinations/edit/" + record.slug)
            }
            className="btn"
          >
            <i
              className="ri-edit-2-line"
              data-toggle="tooltip"
              title="Edit"
            ></i>
          </div>
          <DeletePop
            onConfirm={() =>
              handleDelete(record.id, "destinations/" + record.slug, record.location_id)
            }
          >
            <div>
              {" "}
              <button className="btn delete_btn">
                <i
                  className="ri-delete-bin-line"
                  data-toggle="tooltip"
                  title="Delete"
                ></i>
              </button>
            </div>
          </DeletePop>
        </div>
      ),
    },
  ];
  const handleDelete = async (id, url) => {
    if (checkPermission(permission, "delete_per", "destinations",window?.location?.pathname)) {
      await deleteWebpage(id);
      deleteMenuList({ url });
      addlog("Webpage Deleted", "Webpage", { id }, userDetails.id);
      getData(page, sort, order);
    } else {
      message.error("Missing Permission for delete ");
    }
  };
  const getData = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getAllWebpage({ page_type: "destinations", page, limit: pageSize  });

    setRows(data.data);
    setCount(data.count);
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  useEffect(() => {
    getData();
  }, [page, pageSize]);
  return (
    <Layout type={"read_per"} module_data={"Destinations"}>
      <CustomHeaderTitle title={"Destinations"} />
      <div>
        <div>
          <HeaderBread
            navigation={navigation}
            title={"Destinations"}
          ></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            {active === "listing" && (
              <div className="card">
                <div className="card-header two_item">
                  <h5 className="card-title">Destinations List</h5>
                  <Link
                    to="/website/webpages/destinations/add"
                    className="btn add_v_btn"
                  >
                    Add Destinations
                  </Link>
                </div>

                <div className="card-body">
                  <div className="table_holder">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                      }}
                    ></div>
                    {rows && (
                      <CustomizedTable
                        setRows={setRows}
                        setPageSize={setPageSize}
                        setPage={setPage}
                        pageSize={pageSize}
                        page={page}
                        count={count}
                        columns={columns}
                        rows={rows}
                        title={"Cabin Category"}
                        sortHandler={() => {}}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>{" "}
        {active === "logs" && (
          <Logs
            type={"Page"}
            slug={"/website/webpages/our-ship/edit/"}
            refreshlog={active}
          />
        )}
      </div>
    </Layout>
  );
};

export default DestinationPage;
